import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f7f7f7",
      d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#a1a1b5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m17.75 9.5-6.68 8.016c-.262.314-.392.47-.394.603a.38.38 0 0 0 .139.298c.103.083.307.083.716.083H17l-.75 6 6.68-8.016c.261-.314.392-.47.394-.603a.38.38 0 0 0-.139-.298c-.103-.083-.307-.083-.716-.083h-5.47z"
    }, null, -1)
  ]))]))
}
export default { render: render }